import BrandImage from "components/ui/BrandImage";
import React, { FC } from "react";
import styles from "./Logo.module.scss";
import clsx from "clsx";
import useConfigurationQuery from "hooks/queries/useConfigurationQuery";

interface LogoProps {
  light?: boolean;
  className?: string;
}

const Logo: FC<LogoProps> = ({ light, className }) => {
  const query = useConfigurationQuery();

  return (
    <BrandImage
      path={`data:image/svg+xml;base64,${query.data?.companyLogo}`}
      className={clsx(className, styles.logo, { [styles.light]: light })}
    />
  );
};

export default Logo;
